var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuResourceSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.7223 2.37953C10.8783 1.87383 13.1219 1.8738 15.278 2.37953C18.4251 3.11777 20.8825 5.57512 21.6207 8.72231C22.1264 10.8783 22.1264 13.1219 21.6207 15.278C20.8825 18.4251 18.4251 20.8825 15.278 21.6207C13.122 22.1264 10.8783 22.1264 8.7223 21.6207C5.57513 20.8825 3.11777 18.4251 2.37953 15.278C1.8738 13.1219 1.87383 10.8783 2.37953 8.72231C3.11775 5.57512 5.57512 3.11776 8.7223 2.37953ZM4.18422 9.87953C3.89886 11.5171 3.9461 13.1978 4.32679 14.8209C4.89156 17.2285 6.77168 19.1087 9.17933 19.6735C9.77987 19.8143 10.3884 19.908 10.9996 19.9577V9.87953H4.18422ZM12.9996 16.1207V19.9577C13.6112 19.908 14.2201 19.8144 14.8209 19.6735C16.7748 19.2151 18.3814 17.8905 19.2194 16.1207H12.9996ZM12.9996 14.1207H19.8161C20.1014 12.4832 20.0541 10.8025 19.6735 9.17934C19.1087 6.77168 17.2285 4.89157 14.8209 4.3268L14.4225 4.23988C13.9515 4.1457 13.4764 4.07933 12.9996 4.04066V14.1207ZM10.9996 4.04164C10.3884 4.09137 9.7799 4.18595 9.17933 4.3268C7.22542 4.78512 5.61886 6.10969 4.7809 7.87953H10.9996V4.04164Z",
    fill: "#F5B544"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuResourceSelected);
export default __webpack_public_path__ + "static/media/menu_resource_selected.a5afb3fda7890e8c9da404f785a5fc15.svg";
export { ForwardRef as ReactComponent };